<template>
    <div class="order-manage">
        <el-tabs type="border-card" v-model="currentTab">
            <el-tab-pane label="订单管理" name="order">
              <el-alert
                  title="重要提示"
                  type="success"
                  close-text="知道了"
                  show-icon>
                <p>下面是汇总显示了各个第三方平台的所有订单信息，不同的平台返回的订单信息不一样，有的平台没有返回对应的属性，那么显示就是空白的，是正常现象。</p>
                <p>一个订单里买了不同的商品，每个商品都会形成一个子订单，一个订单可能包含多个子订单，所有子订单的父订单号是相同的</p>
              </el-alert>

              <el-row class="section">
                    <el-col :span="24">
                        <el-form :inline="true" :model="formModel" class="search-area">
                            <el-form-item>
                                <el-input v-model="formModel.openOrderId" placeholder="请输入订单号"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input v-model="formModel.openId" placeholder="请输入商品id"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input v-model="formModel.pid" placeholder="请输入推广位"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">查询</el-button>
                            </el-form-item>
                        </el-form>
                        <el-table :data="items"
                                  height="550"
                                  stripe
                                  border
                                  v-loading="loading"
                                  element-loading-text="拼命加载中"
                                  element-loading-spinner="el-icon-loading"
                                  element-loading-background="rgba(255, 255, 255, 0.5)"
                        >
                            <el-table-column
                                    label="订单id"
                                    fixed
                                    prop="openOrderId"
                                    width="180">
                            </el-table-column>
                            <el-table-column
                                    label="商品id"
                                    width="180">
                                <template slot-scope="scope">
                                    <a :href="itemUrl(scope.row)" target="_blank">{{scope.row.openId}}</a>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="商品名称"
                                    prop="productName"
                                    width="250">
                            </el-table-column>
                            <el-table-column
                                    label="商品图片">
                                <template slot-scope="scope">
                                    <img class="image" :src="scope.row.productPicUrl?scope.row.productPicUrl:(scope.row.orderType=='didi'?'https://tk.xcx.yftaoke.com/images/didi.png':'')"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="店铺名称"
                                    prop="shopName"
                                    width="250">
                            </el-table-column>
                            <el-table-column
                                    label="订单创建时间"
                                    prop="orderCreateTime"
                                    width="180">
                            </el-table-column>
                            <el-table-column
                                    label="推广位"
                                    prop="pid"
                                    width="250">
                            </el-table-column>
                            <el-table-column
                                    label="推广位名称"
                                    prop="adzoneName"
                                    width="180">
                            </el-table-column>
                            <el-table-column
                                    label="订单状态"
                                    prop="orderStatus">
                            </el-table-column>

                            <el-table-column
                                    label="平台"
                                    prop="openProductType">
                            </el-table-column>
                            <el-table-column
                                    label="佣金比例"
                                    prop="commissionRate">
                              <template slot-scope="scope">
                                {{(scope.row.orderType == 'meituan' || scope.row.orderType == 'ele')?'':scope.row.commissionRate}}
                              </template>
                            </el-table-column>
                            <el-table-column
                                    label="实付金额"
                                    prop="realPay">
                            </el-table-column>
                            <el-table-column
                                    label="订单结算时间"
                                    prop="settleTime"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                label="父订单id"
                                prop="parentOrderId"
                                width="180">
                            </el-table-column>
                            <el-table-column
                                    label="操作"
                                    width="160">
                                <template slot-scope="scope">
                                    <el-button @click="newBind(scope.row)" size="mini" class="edit-btn">绑定</el-button>
                                </template>
                            </el-table-column>

                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                    background
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="page"
                                    :page-size="pageSize"
                                    layout="total,prev, pager, next"
                                    :total="totalCount">
                            </el-pagination>
                        </div>

                    </el-col>
                </el-row>
                <el-dialog title="绑定订单" :visible.sync="newDialogShow">
                    <el-row>
                        <el-col :span="24">
                            <el-alert
                                    title="温馨提示"
                                    type="success"
                                    close-text="知道了"
                                    show-icon>
                                <p>可以手动给某个用户绑定订单</p>
                                <p>如果订单已经绑定，请先在【返利管理->订单处理】里面删除订单，再操作</p>
                            </el-alert>
                            <el-form :inline="true" :model="newFormModel" class="search-area">
                                <el-form-item>
                                    <el-input v-model="newFormModel.keyword" placeholder="请输入用户昵称"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="getUsersForSetting">查询</el-button>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-table
                            :data="newItems"
                            ref="newItemsTable"
                            highlight-current-row
                            @current-change="handleCurrentRow"
                            v-if="newItems.length >0"
                            border>
                        <el-table-column
                                type="index"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="用户id"
                                prop="id"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                label="用户">
                            <template slot-scope="scope">
                                <span>{{scope.row.nickname}}</span>
                                <img class="head-img" :src="scope.row.headPicUrl"/>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div slot="footer" class="dialog-footer">
                        <el-button @click="newDialogShow = false">取 消</el-button>
                        <el-button type="primary" @click="doBind('newForm')" v-loading.fullscreen.lock="saving">确 定
                        </el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
            <el-tab-pane label="维权订单" name="rights" v-if="accountValid">
                <el-row class="section">
                    <el-col :span="12">
                        <el-alert
                                title="温馨提示"
                                type="success"
                                close-text="知道了"
                                show-icon>
                            <p>直接上传淘宝联盟下载的维权记录表格，不要另存为，不要改名！不要另存为，不要改名！</p>
                        </el-alert>
                        <el-form :model="uploadForm" ref="newForm" label-position="left">
                            <el-form-item>
                                <el-upload
                                        class="upload-demo"
                                        action="https://jsonplacfdfsdfeholder.typicode.com/posts/"
                                        :on-preview="handlePreview"
                                        :with-credentials="true"
                                        :on-remove="handleRemove"
                                        :on-change="handleChange"
                                        :multiple="false"
                                        :limit="1"
                                        accept="image/csv"
                                        :on-success="handleSuccess"
                                        :before-upload="beforeUpload"
                                        :on-exceed="handleExceed"
                                        :on-error="handleError"
                                        :file-list="files"
                                        :auto-upload="false"
                                        list-type="picture">
                                    <el-button size="small" type="primary">上传维权订单</el-button>
                                    <div slot="tip" class="el-upload__tip">
                                    </div>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                        <el-button type="primary" @click="saveUserRightsFile('newForm')">确 定</el-button>
                    </el-col>
                </el-row>

            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import {openOrderApi} from "../../common/openOrderApi";
    import {userApi} from "../../common/userApi";
    import {rebateApi} from "../../common/rebate";
    import {accountConfigApi} from "../../common/accountConfigApi";

    export default {
        data() {
            return {
                formModel: {},
                saving:false,
                newFormModel: {},
                currentTab: 'order',
                items: [],
                page: 1,
                pageSize: 20,
                totalCount: 0,
                loading: false,
                newDialogShow: false,
                currentOrder: null,
                currentNewRow: null,
                file: null,
                uploadForm: {},
                newItems: [],
                isUploading: false,
                accountValid: false
            }
        },
        computed: {
            itemUrl() {
                return function (item) {
                    if (item.openProductType == 'TAOBAO' || item.openProductType == 'TMALL') {
                        return "https://item.taobao.com/item.htm?id=" + item.openId;
                    } else if (item.openProductType == 'JD') {
                        return "https://item.jd.com/" + item.openId + ".html"
                    } else if (item.openProductType == 'PDD') {
                        return "https://mobile.yangkeduo.com/goods2.html?goods_id=" + item.openId;

                    }
                }
            },
        },
        mounted() {
            var that = this
            accountConfigApi.getAccountStatus.call(that, {}, function (res) {
                if (res.result.valid) {
                    that.accountValid = true;
                }
            })
            that.loading = true;
            that.formModel.page = that.page
            that.formModel.pageSize = that.pageSize
            openOrderApi.getOpenOrderItems.call(this, that.formModel, function (res) {
                that.loading = false;
                if (res.result.data) {
                    that.items = res.result.data
                }
                if (res.result.totalCount) {
                    that.totalCount = res.result.totalCount
                }
            }, function (res) {
                that.loading = false;
            })

        },
        methods: {
            saveUserRightsFile(formName) {
                if (this.isUploading) {
                    return;
                }
                this.isUploading = true;
                var that = this;
                if (that.file == null) {
                    this.$message({
                        showClose: true,
                        message: '上传文件不能为空',
                        type: 'error'
                    });
                    return false;
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.checkFile(this.file)) {
                            var formData = new FormData();
                            formData.append("file", that.file.raw)
                            openOrderApi.uploadUserRightsFile.call(that, formData, function (res) {
                                that.$message({
                                    showClose: true,
                                    message: '上传成功',
                                    type: 'success'
                                });
                                that.isUploading = false
                            }, function (res) {
                                that.isUploading = false
                            })
                        }
                    } else {
                        console.log('error submit!!');
                        that.isUploading = false
                        return false;
                    }

                });

            },

            handleChange(file, fileList) {
                console.log("handleChange")
                console.log(file, fileList)
                this.file = file

            },
            handleRemove(file, fileList) {//移除图片
                console.log("handleRemove")
                console.log(file, fileList);
            },
            handlePreview(file) {//预览图片时调用
                console.log("handlePreview");
                console.log(file);
            },

            checkFile: function (file) {
                if (file == null) return true;
                return true;
            },
            beforeUpload(file) {//文件上传之前调用做一些拦截限制
                console.log("beforeUpload");
                console.log(file);
                this.file = file;
                return this.checkFile(file);
            },
            handleSuccess(res, file) {//图片上传成功
                console.log(res);
                console.log(file);
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            handleError(err, file, fileList) {//图片上传失败调用
                console.log("handleError")
                console.log(err)
            },

            handleExceed(file, fileList) {//图片上传超过数量限制
                console.log("handleExceed")
                console.log(file, fileList);
                this.$message({
                    showClose: true,
                    message: '最大支持上传1个文件',
                    type: 'error'
                });
            },
            newBind(item) {
                this.newDialogShow = true;
                this.currentNewRow = {}
                this.newItems = []
                this.currentOrder = item
            },
            getUsersForSetting() {
                var that = this;
                userApi.getUnionUsers.call(that, {nickname: that.newFormModel.keyword},
                    function (res) {
                        if (res.result.items) {
                            that.newItems = res.result.items;
                            if (res.result.items.length == 1) {
                                that.currentNewRow = res.result.items[0]
                            }
                        }

                    },
                    function (res) {
                        console.log(res)
                    }
                )
            },

            doBind(formName) {
                var that = this
                rebateApi.submitOrder.call(that, {
                    orderId: that.currentOrder.openOrderId,
                    parentOrderId: that.currentOrder.parentOrderId,
                    userId: that.currentNewRow.id
                }, function (res) {

                }, function (res) {

                })
            },


            onSubmit() {
                var that = this
                that.page = 1
                that.formModel.page = that.page
                that.formModel.pageSize = that.pageSize
                openOrderApi.getOpenOrderItems.call(this, that.formModel, function (res) {
                    if (res.result.data) {
                        that.items = res.result.data
                    }
                    if (res.result.totalCount) {
                        that.totalCount = res.result.totalCount
                    }
                })
            },
            handleCurrentRow(val) {
                this.currentNewRow = val;
            },
            handleCurrentChange() {
                var that = this
                that.formModel.page = that.page
                that.formModel.pageSize = that.pageSize
                openOrderApi.getOpenOrderItems.call(that, that.formModel, function (res) {
                    if (res.result.data) {
                        that.items = res.result.data
                    }
                    if (res.result.totalCount) {
                        that.totalCount = res.result.totalCount
                    }
                })
            }
        }
    }

</script>
<style lang="scss">
    .order-manage {
        text-align: left;

        .search-area {
            text-align: left;
        }


        .image {
            width: 60px;
            height: 60px;
        }

        .head-img {
            width: 30px;
            height: 30px;
            vertical-align: middle;
            margin-left: 5px;
        }
    }
</style>